import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Col, Container, Row } from 'react-bootstrap'
import InputField from '../component/InputField'
import PrimaryGradientButton from '../component/PrimaryGradientButton'
import SelectDropDown from '../component/SelectDropDown'
import RegistrationService from '../services/registration'
import OtherService from '../services/Other'
import { useNavigate } from 'react-router-dom'
import AlertMsg from '../component/AlertMsg'
import toast from 'react-hot-toast'
import { useSelector } from 'react-redux'
import useScrollToTop from '../hooks/useScrollToTop'
const AddNewAddress = () => {
    useScrollToTop();
    const tokens =  useSelector(
        state => state.userTypeSlice.token,
      );
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    //Validation
    const [isBuilding, setIsBuilding] = useState('')
    const [isArea, setIsArea] = useState('')
    const [isPincode, setIsPincode] = useState('')
    const [isLandmark, setIsLandmark] = useState('')
    const [countryValidationError, setCountryValidationError] = useState('')
    const [stateValidationError, setStateValidationError] = useState('')
    const [cityValidationError, setCityValidationError] = useState('')
    const [districtValidationError, setDistrictValidationError] = useState('')
    //Country
    const [isCountryList, setIsCountryList] = useState([])
    const [contentCountry, setContentCountry] = useState({ id: "", title: "" });
    //State
    const [isStateList, setIsStateList] = useState([])
    const [contentState, setContentState] = useState({ id: "", title: "" });
    //District
    const [isDistrictList, setIsDistrictList] = useState([])
    const [contentDistrict, setContentDistrict] = useState({ id:'', title: '' });
    //City
    const [isCityList, setIsCityList] = useState([])
    const [contentCity, setContentCity] = useState({ id: "", title: "" });
    const [isLoginSuccess, setIsLoginSuccess] = useState({ isLogin: true, heading: '', text: '' })
    const [showAlert, setShowAlert] = useState(false);
    //Due All Form Fiels//
    const [isAddress, setIsAddress] = useState(
        {
            buildingNo: '',
            area: '',
            pincode: '',
            landmark: '',
            otp: ''
        }
    )
    const [otpStatus, setOtpStatus] = useState(false);
    const [pincodeData, setPincodeData] = useState(null);

    const getPincodeDetails = async (pincode) => {
    try {
        const response = await OtherService.getPincodeDetails(pincode);
        const data = response?.data?.data;
        console.log("DATA=============",data);
        if (response?.data?.status === true && data && Object.keys(data).length > 0) {
            setPincodeData(data);
        } else {
            setPincodeData(null);
        }
    } catch (error) {
        console.error('Pincode API error:', error);
        setPincodeData(null);
    }
};
    //All Countries
    useEffect(() => {
        const fetchCountryData = async () => {
            try {
                const response = await RegistrationService.allCountries();
                const countryNames = response.response.countriesDetails.filter(item =>
                    ['India'].includes(item.name),
                ).map(country =>
                (
                    {
                        id: country.id,
                        title: country.name
                    }
                )
                );
                setIsCountryList(countryNames[0])

            }
            catch (error) {
                console.error('Error fetching country data:');
            }
        };
        fetchCountryData()
    }, [])
    //All States
    useEffect(() => {
        const stateListFetch = async () => {

            if (isCountryList.id) {
                try {
                    if (pincodeData?.state_id) {
                        setContentState({ id: pincodeData.state_id, title: pincodeData.state_name });
                    }
                    const stateListResponse = await RegistrationService.allStates(isCountryList.id);
                    if(stateListResponse.success == true)
                    {
                        if(stateListResponse.response.statesDetails.length > 0)
                        {
                         const statesDetails = stateListResponse.response.statesDetails;
                         setIsStateList(statesDetails.map((item) => ({
                                id: item.id,
                                title: item.name
                            })));
                        }

                    }
                    
                } catch (error) {
                    console.error("Error");
                }
            };
        };

        stateListFetch();
    }, [isCountryList.id, pincodeData]);
    //All City
    useEffect(() => {
        const fetchCityList = async () => {
            if (isCountryList.id && contentState.id) {
                try {
                    const cityListResponse = await RegistrationService.allCities(isCountryList.id, contentState.id);
                    setIsCityList(cityListResponse.response.citiesDetails.map((item) =>
                    (
                        {
                            id: item.id,
                            title: item.name
                        }
                    )
                    ))

                }
                catch (error) {
                    console.error("Error")

                }
            }
        }
        fetchCityList()
    }, [isCountryList.id, contentState.id])
    //All Districts
    useEffect(() => {
        const fetchDistrictList = async () => {
            const token = localStorage.getItem("access_token");
            if (isCountryList.id && contentState.id) {
                try {
                    if (pincodeData?.district_id) {
                        setContentDistrict({ id: pincodeData.district_id, title: pincodeData.district_name });
                    }
                    const districtListResponse = await RegistrationService.allDistricts(isCountryList.id, contentState.id, tokens.access);
                    
                    if (districtListResponse.success === true) {
                        if (districtListResponse.response.districtDetails.length > 0) {
                            setIsDistrictList(districtListResponse.response.districtDetails.map((item) => ({
                                id: item.id,
                                title: item.name
                            })));
                        }
                    }
                } catch (error) {
                    console.error("Error");
                }
            }
        }
        fetchDistrictList();
    }, [isCountryList.id, contentState.id, tokens, pincodeData]);
    
    const handleContentCountryNameChange = (selectedValue) => {
        setContentCountry(selectedValue);
        setCountryValidationError('');

    }
    const handleContentStateNameChange = (selectedValue) => {
        setContentState(selectedValue)
        setStateValidationError('')
    }
    const handleContentCityNameChange = (selectedValue) => {
        setContentCity(selectedValue)
        setCityValidationError('')
    }
    const handleContentDistrictNameChange = (selectedValue) =>{
        setContentDistrict(selectedValue)
        setDistrictValidationError('')
    }
    const handleNameInput = (e) => {
        const { name, value } = e.target;
        if (name === 'pincode') {
            const regex = /^[0-9]*$/;
            if (!regex.test(value)) {
                setIsPincode('Pincode must be numeric');
                return;
            }
            setIsAddress({ ...isAddress, [name]: value });
            setIsPincode('');
            setPincodeData(null);
            setContentState({ id: '', title: '' });
            setContentDistrict({ id: '', title: '' });
            if (value.length === 6) {
                getPincodeDetails(value);
            }
            return;
        }
        setIsAddress({ ...isAddress, [name]: value })
        switch (name) {
            case 'buildingNo':
                setIsBuilding('');
                break;
            case 'area':
                setIsArea('');
                break;
            case 'pincode':
                setIsPincode('');
                break;
            case 'landmark':
                setIsLandmark('');

        }
    }
    const navigate = useNavigate();
    //Address Change
    const handleAddressChange = async () => {
        if(!contentState.id || !contentDistrict.id ||  !isAddress.area || !isAddress.buildingNo || !isAddress.landmark || !isAddress.pincode) {
            toast.error("Please fill all the required details");
            return;
       }
       if(!isAddress.otp) {
            toast.error("Please enter OTP");
            return;
       }

        const validations = [
            { value: isAddress.buildingNo, setter: setIsBuilding, message: 'Building No is required.' },
            { value: isAddress.area, setter: setIsArea, message: 'Area is required.' },
            { value: isAddress.pincode, setter: setIsPincode, message: 'Pincode is required.' },
            { value: isAddress.landmark, setter: setIsLandmark, message: 'Landmark is required.' },
            { value: contentState.id, setter: setStateValidationError, message: 'State is required.' },
            { value: contentDistrict.id, setter: setDistrictValidationError, message: 'District is required.' },
        ]
        let isValid = true;
        validations.forEach(({ value, setter, message }) => {
            if (!value) {
                setter(message);
                isValid = false;
            }
            else {
                setter(''); // Clear the error message
            }
        });
        if (isValid) {
            const token = localStorage.getItem('access_token')
            const payload = {
                
                recipient: '',
                address: isAddress.buildingNo,
                landmark: isAddress.landmark,
                city: contentDistrict.title,
                state: parseInt(contentState.id),
                district: parseInt(contentDistrict.id),
                country: parseInt(isCountryList.id),
                taluka: 'null',
                pin_code: isAddress.pincode,
                post_office: isAddress.area,
                is_default: '0',
                is_active: '1',
                address_status: '0',
                address_change_type: '0',
                otp: isAddress.otp
                
            }
           
            setIsButtonLoading(true)
            try {
                const AddNewAddressSubmit = await OtherService.addAddress(payload, token)
                setIsButtonLoading(false)
                if (AddNewAddressSubmit.response_code == 200) {
                    toast.success(AddNewAddressSubmit.message)
                    setTimeout(() => {
                        navigate('/address-list')
                    }, 4000)

                }
                else {
                    toast.error(AddNewAddressSubmit.errorMessage.error)
                }
            }

            catch (error) {
                toast.error("Something went wrong !")
            }
        }

    }

    function sendOtp() {
        const payloadOtp = {};
        setIsButtonLoading(true);
        RegistrationService.addressOtp(payloadOtp, tokens.access).then(res => {
          setIsButtonLoading(false);
          if (!res.error) {
            if (res.response.status == 'true') {
              setOtpStatus(true);
              toast.success("Otp has been send !")
            } else {
                toast.error("Cannot send otp right now !")
            }
          } else {
            toast.error('Something went wrong !');
          }
        }).catch(() => {
            setIsButtonLoading(false);
        });
      }
    return (
        <>
            <BreadCrumbSecttion pageTitle="Add New Address" currentPageName="Add New Address" />
            <section className='padTop50'>
                <Container>
                    <Row className='justify-content-center align-item-center h-100'>
                        <Col xs={12} >
                            <div className='userInfoBox'>
                                <div className='dashboard-title'>
                                    <h4>Please Add Your New Address</h4>
                                </div>
                                <div className="dashboard-details">
                                    <Row>

                                        <Col xs={12} lg={3}>
                                            <InputField
                                                inputFieldLabel="Flat,House,Building No"
                                                requiredStar="*"
                                                name="buildingNo"
                                                value={isAddress.buildingNo}
                                                onChange={handleNameInput} />
                                            {isBuilding && (
                                                <div className="error-message">{isBuilding}</div>
                                            )}
                                        </Col>
                                        <Col xs={12} lg={3}>
                                            <InputField
                                                inputFieldLabel="Area, Street"
                                                requiredStar="*"
                                                name="area"
                                                value={isAddress.area}
                                                onChange={handleNameInput} />
                                            {isArea && (
                                                <div className="error-message">{isArea}</div>
                                            )}
                                        </Col>
                                        {/* <Col xs={12} lg={3}>
                                            <SelectDropDown labelName="Country"
                                                requiredStar="*"
                                                options={isCountryList}
                                                setSelectedValue={setContentCountry}
                                                selectedValue={contentCountry}
                                                onChange={handleContentCountryNameChange}
                                                page='searchFilter'
                                            />
                                            {countryValidationError && (
                                                <div className="error-message">{countryValidationError}</div>
                                            )}
                                        </Col> */}
                                        <Col xs={12} lg={3}>
                                            <InputField
                                                inputFieldLabel="Pincode"
                                                requiredStar="*"
                                                name="pincode"
                                                value={isAddress.pincode}
                                                onChange={handleNameInput} />
                                            {isPincode && (
                                                <div className="error-message">{isPincode}</div>
                                            )}
                                        </Col>
                                        <Col xs={12} lg={3}>
                                            <SelectDropDown labelName="State"
                                                requiredStar="*"
                                                options={isStateList || pincodeData?.state_name}
                                                setSelectedValue={setContentState}
                                                selectedValue={contentState}
                                                onChange={handleContentStateNameChange}
                                                page='searchFilter'
                                                disabled={pincodeData?.state_name}
                                                />
                                            {stateValidationError && (
                                                <div className="error-message">{stateValidationError}</div>
                                            )}
                                        </Col>
                                        <Col xs={12} lg={3}>
                                            <SelectDropDown labelName="District"
                                                requiredStar="*"
                                                options={isDistrictList || pincodeData?.district_name}
                                                setSelectedValue={setContentDistrict}
                                                selectedValue={contentDistrict}
                                                onChange={handleContentDistrictNameChange}
                                                page='searchFilter' 
                                                disabled={pincodeData?.district_name}
                                                />
                                                {districtValidationError && (
                                                    <div className="error-message">{districtValidationError}</div>
                                                )}
                                        </Col>
                                        <Col xs={12} lg={3}>
                                            <InputField
                                                inputFieldLabel="Landmark"
                                                requiredStar="*"
                                                name="landmark"
                                                value={isAddress.landmark}
                                                onChange={handleNameInput} />
                                            {isLandmark && (
                                                <div className="error-message">{isLandmark}</div>
                                            )}
                                        </Col>
                                        {otpStatus && <Col xs={12} lg={3}>
                                                <InputField
                                                    inputFieldLabel="OTP"
                                                    requiredStar="*"
                                                    name="otp"
                                                    value={isAddress?.otp}
                                                    onChange={handleNameInput}
                                                />

                                            </Col>}
                                            {otpStatus && <Col xs={12} lg={3}>
                                                <PrimaryGradientButton
                                                    buttonText={isButtonLoading ? "Processing..." : "Submit"}
                                                    className="mt-28"
                                                    onClick={handleAddressChange}
                                                    disabled={isButtonLoading} />

                                            </Col>}
                                            {!otpStatus && <Col xs={12} lg={3}>
                                                <PrimaryGradientButton
                                                    buttonText={isButtonLoading ? "Processing..." : "Send OTP"}
                                                    className="mt-28"
                                                    onClick={sendOtp}
                                                    disabled={isButtonLoading} />

                                            </Col>}
                                    </Row>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default AddNewAddress